import { CloseIcon } from 'src/domains/layouts/shared/assets/icons/CloseIcon';

import styled from '@emotion/styled';

import { withConfig } from 'src/withConfig';

import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';

import { css, SerializedStyles } from '@emotion/react';



const checkboxWrapper = (theme: EmotionTheme, signUpCheckboxTC: boolean): SerializedStyles => {

    if (signUpCheckboxTC === true) {

        return css`

            margin-top: 16px;

        `;

    }



    return css`

        border: 1px solid ${theme.star.signUp.borderColor};

        color: ${theme.star.signUp.txtColor};

        font-size: ${theme.star.fontSize.small};

        line-height: 1.3334;

        margin-top: 24px;

        padding: 16px;

    `;

};



interface InfoWrapperType {

    signUpCheckboxTC: boolean;

}

export const InfoWrapper = withConfig(theme => styled('div', { label: 'InfoWrapper' }) <InfoWrapperType>`

    ${({ signUpCheckboxTC }): SerializedStyles => checkboxWrapper(theme, signUpCheckboxTC)};

`);



export const TermsButton = withConfig(theme => styled('button', { label: 'TermsButton' })`

    background-color: transparent;

    border: 0;

    color: ${theme.star.signUp.termsAndConditions.txtColor};

    cursor: pointer;

    font-weight: ${theme.star.fontWeight.bold};

    padding: 0;

    text-decoration: none;

`);





export const InfoContentWrapper = withConfig(theme => styled('div', { label: 'InfoContentWrapper' })`

    background-color: ${theme.star.staticPage.bgColor};

    color: ${theme.star.layoutGlobal.txtColor};

    left: 0;

    position: absolute;

    top: 0;

    width: 100%;

    z-index: ${theme.star.zIndexGlobal.above};

    height: 100%;

    overflow: auto;

`);



interface InfoContentTitleType {

    hasArrow?: boolean;

}



export const InfoContentTitle = withConfig(theme => styled('div', { label: 'InfoContentTitle' })<InfoContentTitleType>`

    align-items: center;

    background-color: ${theme.star.signUp.bgColor};

    color: ${theme.star.signUp.txtColor};

    display: flex;

    font-size: ${theme.star.fontSize.regular};

    font-weight: ${theme.star.fontWeight.bold};

    height: 48px;

    justify-content: ${({ hasArrow }): string => hasArrow === true ? "flex-start" : "space-between"};

    padding: 16px;

    ${({ hasArrow }): string | null => hasArrow === true ? "padding-left: 0" : null};

    text-transform: uppercase;

`);



export const InfoContent = withConfig(theme => styled('div', { label: 'InfoContent' })`

    color: ${theme.star.staticPage.txtColor};

    height: 100%;

    line-height: 1.6;

    overflow-x: hidden;

    padding: 10px 16px 16px;

    h6,

    h5,

    h4,

    h3,

    h2,

    h1 {

        color: ${theme.star.staticPage.txtColor};

        font-weight: ${theme.star.fontWeight.bold};

        line-height: 1.3;

        margin: 0 0 5px 0;

        padding: 0;

    }

    h6,

    h5,

    h4,

    h3,

    h2 {

        margin: 16px 0 5px;

    }

    h1 {

        font-size: 1.5rem;

    }

    p {

        margin-top: 0;

        line-height: 1.6;

    }

    ul {

        padding: 5px 0;

    }

    ul > li {

        padding-left: 15px;

        position: relative;

        margin-bottom: 10px;

    }

    ul > li::before {

        background: ${theme.star.staticPage.bgColorSecondary};

        border-radius: 50px;

        content: '';

        height: 5px;

        left: 0;

        position: absolute;

        top: 5px;

        width: 5px;

    }

    ol {

        list-style: decimal;

        list-style-position: outside;

        margin-left: 20px;

    }

    ol > li {

        margin-bottom: 10px;

    }

    a {

        color: ${theme.star.staticPage.linkColor};

    }

`);



export const CloseButton = styled('button', { label: 'CloseButton' })`

    background-color: transparent;

    border: 0;

    height: 20px;

    outline: none;

    padding: 0;

    position: relative;

    width: 20px;

`;



export const StyledCloseIcon = withConfig(theme => styled(CloseIcon, { label: 'StyledCloseIcon' })`

    cursor: pointer;

    fill: ${theme.star.signUp.termsAndConditions.bgColor};

    width: 20px;

`);



export const CheckboxWrapper = styled('div', { label: 'CheckboxWrapper' })`

    margin-bottom: 8px;

`;

